import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, styled } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useLogoutMutation, useRemoveFcmTokenMutation } from '../features/Auth/authApiSlice';
import { selectCurrentUser, selectDeviceType } from '../features/Auth/authSlice';
import { useNavigate } from 'react-router-dom';
import { clearAuth } from '../features/Auth/Utility/ClearAuth';

const CustomHeader = styled(DialogTitle)({
  backgroundColor: '#0A4FAC',
  color: '#fff',
  fontWeight: 'bold',
  fontSize: '16px',
  padding: '8px 16px',
  minHeight: '40px',
  lineHeight: '1.2',
});

const CustomButton = styled(Button)({
  backgroundColor: '#0A4FAC',
  color: '#fff',
  padding: '6px 20px',
  borderRadius: '8px',
  textTransform: 'none',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#0A4FAC',
  },
});

const CenteredActions = styled(DialogActions)({
  justifyContent: 'center',
  borderTop: '1px solid #ccc',
});

const ProfileImageDialog = ({open}) => {
  const user = useSelector(selectCurrentUser);
  const [logout] = useLogoutMutation();
  const [removeFCMToken] = useRemoveFcmTokenMutation();
  const deviceType = useSelector(selectDeviceType);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const handleLogout = async () => {
    await removeFCMToken({ empId: user.empId, deviceType }).unwrap();
    logout();
    clearAuth(dispatch);
    navigate('/auth');
  };
  return (
    <Dialog open={open}>
      <CustomHeader>G•NXT</CustomHeader>
      <DialogContent sx={{ justifyContent: 'center' }}>
        Kindly update your Profile Image in ERP to Access the Application.
      </DialogContent>
      <CenteredActions>
        <CustomButton onClick={handleLogout}>Logout</CustomButton>
      </CenteredActions>
    </Dialog>
  );
};

export default ProfileImageDialog;
